import { storage } from "@/features/app-context/utils";

import { enMessages, type MessageId } from "./messages/en";
import { pseudoMessages } from "./messages/en-XA";

export const DEFAULT_LOCALE = "en";
export const PSEUDO_LOCALE = "en-XA";
export const SUPPORTED_LOCALES = [DEFAULT_LOCALE, PSEUDO_LOCALE] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const messages: Record<SupportedLocale, Record<MessageId, string>> = {
  en: enMessages,
  "en-XA": pseudoMessages,
};

export function isSupportedLocale(locale: string): locale is SupportedLocale {
  return SUPPORTED_LOCALES.includes(locale as SupportedLocale);
}

export function detectLocale(): SupportedLocale {
  const search = new URLSearchParams(window.location.search);
  const queryLocale = search.get("locale");
  if (queryLocale && isSupportedLocale(queryLocale)) return queryLocale;

  const storedLocale = storage.get("or:locale");
  if (storedLocale && isSupportedLocale(storedLocale)) return storedLocale;

  const browserLocale = navigator.language;
  if (isSupportedLocale(browserLocale)) return browserLocale;

  const baseLocale = browserLocale.split("-")[0];
  if (isSupportedLocale(baseLocale)) return baseLocale;

  return DEFAULT_LOCALE;
}
